export default "__VITE_ASSET__D1kDqks3__"